export default __webpack_public_path__ + "static/media/8.43593f39.jpg";